'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  inline: _react.PropTypes.bool,
  disabled: _react.PropTypes.bool,
  tabs: _react.PropTypes.bool,
  pills: _react.PropTypes.bool,
  stacked: _react.PropTypes.bool,
  navbar: _react.PropTypes.bool,
  tag: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
  className: _react.PropTypes.string,
  cssModule: _react.PropTypes.object
};

var defaultProps = {
  tag: 'ul'
};

var Nav = function Nav(props) {
  var className = props.className;
  var cssModule = props.cssModule;
  var tabs = props.tabs;
  var pills = props.pills;
  var inline = props.inline;
  var stacked = props.stacked;
  var navbar = props.navbar;
  var Tag = props.tag;

  var attributes = _objectWithoutProperties(props, ['className', 'cssModule', 'tabs', 'pills', 'inline', 'stacked', 'navbar', 'tag']);

  var classes = (0, _utils.mapToCssModules)((0, _classnames2.default)(className, 'nav', {
    'navbar-nav': navbar,
    'nav-tabs': tabs,
    'nav-pills': pills,
    'nav-inline': inline,
    'nav-stacked': stacked,
    disabled: attributes.disabled
  }), cssModule);

  return _react2.default.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;

exports.default = Nav;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactstrap/lib/Nav.js
 ** module id = 1189
 ** module chunks = 0
 **/